import axios from 'axios';

const API_URL = 'https://venkatadri.in/venkatadrinewsapp/news_back_end_laravel/public/api/api/v1';

// Create axios instance with default config
const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Add token to requests if it exists
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Handle response errors
api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            const currentPath = window.location.pathname;
            const publicPaths = ['/', '/homepage', '/login'];
            if (!publicPaths.includes(currentPath)) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('role');
                localStorage.removeItem('permissions');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

// Login User
export const login = async (email, password) => {
    try {
        const response = await api.post('/login', { email, password });

        if (response.data.success) {
            // Store token and user data
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
            localStorage.setItem('role', response.data.role);
            localStorage.setItem('permissions', JSON.stringify(response.data.permissions || []));
        }

        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Login failed' };
    }
};

// Logout User
export const logout = async () => {
    try {
        await api.post('/logout');
    } catch (error) {
        console.error('Logout error:', error);
    } finally {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('role');
        localStorage.removeItem('permissions');
    }
};

// Get Current User
export const getCurrentUser = async () => {
    try {
        const response = await api.get('/me');
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Failed to get user' };
    }
};

// Check if user is authenticated
export const isAuthenticated = () => {
    const token = localStorage.getItem('token');
    return token !== null && token !== undefined;
};

// Get user role
export const getUserRole = () => {
    return localStorage.getItem('role');
};



// Check if user has specific role
export const hasRole = (role) => {
    const userRole = getUserRole();
    return userRole === role;
};

export default api;